import "@fortawesome/fontawesome-svg-core/styles.css";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

library.add(
    fas.faCog,
    fas.faInfo,
    fas.faUpload,
    fas.faTrash,
    fas.faHandshake,
    fas.faUserShield,
    fas.faInfoCircle,
    fas.faGlobe,
    fas.faSearch,
    fas.faLifeRing,
    fas.faQuestion,
    fas.faQuestionCircle,
    fas.faStopCircle,
    fas.faCircleNotch,
    fas.faDotCircle,
    fas.faPlayCircle,
    fas.faCheckCircle,
    fas.faExclamationCircle,
    fas.faCheckCircle,
    fas.faArrowCircleDown,
    fas.faEdit,
    fas.faList,
    fas.faListCheck,
    fas.faFilePdf,
    fas.faFileCsv,
    fas.faFileArchive,
    fas.faFileContract,
    fas.faEye,
    fas.faFile,
    fas.faUserEdit,
    fas.faUserPlus,
    fas.faPlus,
    fas.faMinus,
    fas.faClock,
    fas.faUserClock,
    fas.faShieldAlt,
    fas.faMinusCircle,
    fas.faUserMinus,
    fas.faPlay,
    fas.faTools,
    fas.faAddressCard,
    fas.faUser,
    fas.faUsers,
    fas.faArchive,
    fas.faFaucet,
    fas.faEnvelope,
    fas.faFolder,
    fas.faNetworkWired,
    fas.faServer,
    fas.faBars,
    fas.faImage,
    fas.faDatabase,
    fas.faComments,
    fas.faSitemap,
    fas.faCogs,
    fas.faTag,
    fas.faSync,
    fas.faBolt,
    fas.faPooStorm,
    fas.faStar,
    fas.faStarHalf,
    fas.faDollarSign,
    fas.faFlask,
    fas.faHashtag,
    fas.faBug,
    fas.faChartLine,
    fas.faTimes,
    fas.faMailBulk,
    fas.faPaperPlane,
    fas.faExclamation,
    fas.faFileCode,
    fas.faArrowCircleUp,
    fas.faFileUpload,
    fas.faFileDownload,
    fas.faFolderPlus,
    fas.faStop,
    fas.faPause,
    fas.faLeftRight,
    fas.faUpDown,
    fas.faAngleDown,
    fas.faAngleLeft,
    fas.faArrowRight,
    fas.faArrowLeft,
    fas.faSquareMinus,
    fas.faRedo,
    fas.faUndo,
    fas.faStar,
    far.faStar,
    fas.faComment
);
library.add(far.faFile, far.faCheckCircle, far.faEnvelopeOpen);

dom.watch();
